// Luxury Destinations for PRIVIA Villas

export const destinationRegions = {
  caribbean: {
    name: "Caraïbes",
    description: "Paradis tropical d'exception",
    destinations: [
      {
        id: "turks-caicos",
        name: "Turks & Caicos",
        country: "Turks & Caicos",
        description: "Eaux cristallines et plages immaculées",
        image: "https://images.unsplash.com/photo-1748711411855-6102933fb14a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
        villaCount: 12,
        priceRange: "25k - 50k €/semaine"
      },
      {
        id: "st-barths",
        name: "Saint-Barthélemy",
        country: "France",
        description: "L'élégance française aux Antilles",
        image: "https://images.unsplash.com/photo-1651594862785-097d799f36ea?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
        villaCount: 18,
        priceRange: "30k - 75k €/semaine"
      },
      {
        id: "st-martin",
        name: "Saint-Martin",
        country: "France/Pays-Bas",
        description: "Charme franco-hollandais unique",
        image: "https://images.unsplash.com/photo-1575110185635-537f26549b1f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
        villaCount: 8,
        priceRange: "20k - 45k €/semaine"
      },
      {
        id: "anguilla",
        name: "Anguilla",
        country: "Territoire britannique",
        description: "Sérénité et sophistication",
        image: "https://images.unsplash.com/photo-1748711411855-6102933fb14a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
        villaCount: 6,
        priceRange: "22k - 55k €/semaine"
      },
      {
        id: "mustique",
        name: "Mustique",
        country: "Saint-Vincent-et-les-Grenadines",
        description: "L'île privée des célébrités",
        image: "https://images.unsplash.com/photo-1651594862785-097d799f36ea?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
        villaCount: 4,
        priceRange: "40k - 100k €/semaine"
      }
    ]
  },
  
  mediterranean: {
    name: "Méditerranée",
    description: "Art de vivre méditerranéen d'exception",
    destinations: [
      // France - Côte d'Azur
      {
        id: "st-tropez",
        name: "Saint-Tropez",
        country: "France",
        description: "Glamour légendaire de la Riviera",
        image: "https://images.unsplash.com/photo-1587579785043-eccb9f70391d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
        villaCount: 25,
        priceRange: "35k - 80k €/semaine"
      },
      {
        id: "cannes",
        name: "Cannes",
        country: "France",
        description: "Prestige cinématographique mondial",
        image: "https://images.unsplash.com/photo-1703152792682-a1fe5f3dedb4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
        villaCount: 22,
        priceRange: "30k - 65k €/semaine"
      },
      {
        id: "cap-ferrat",
        name: "Cap Ferrat",
        country: "France",
        description: "Péninsule d'exception et de discrétion",
        image: "https://images.unsplash.com/photo-1587579785043-eccb9f70391d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
        villaCount: 8,
        priceRange: "50k - 120k €/semaine"
      },
      {
        id: "cap-antibes",
        name: "Cap d'Antibes",
        country: "France",
        description: "Refuge aristocratique méditerranéen",
        image: "https://images.unsplash.com/photo-1703152792682-a1fe5f3dedb4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
        villaCount: 15,
        priceRange: "28k - 70k €/semaine"
      },
      {
        id: "eze",
        name: "Èze",
        country: "France",
        description: "Village perché aux vues époustouflantes",
        image: "https://images.unsplash.com/photo-1587579785043-eccb9f70391d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
        villaCount: 6,
        priceRange: "32k - 75k €/semaine"
      },
      
      // France - Corse
      {
        id: "porto-vecchio",
        name: "Porto-Vecchio",
        country: "Corse, France",
        description: "Perle du sud corse",
        image: "https://images.unsplash.com/photo-1632464477484-04c89665d5bb?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
        villaCount: 14,
        priceRange: "18k - 45k €/semaine"
      },
      {
        id: "bonifacio",
        name: "Bonifacio",
        country: "Corse, France",
        description: "Citadelle suspendue sur falaises",
        image: "https://images.unsplash.com/photo-1632153604387-1a54695882a2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
        villaCount: 10,
        priceRange: "20k - 50k €/semaine"
      },
      {
        id: "calvi",
        name: "Calvi",
        country: "Corse, France",
        description: "Balagne authentique et raffinée",
        image: "https://images.unsplash.com/photo-1632464477484-04c89665d5bb?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
        villaCount: 8,
        priceRange: "16k - 40k €/semaine"
      },

      // Monaco
      {
        id: "monaco",
        name: "Monaco",
        country: "Principauté de Monaco",
        description: "L'épicentre du luxe méditerranéen",
        image: "https://images.unsplash.com/photo-1659557128405-67bad0c9ad35?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
        villaCount: 5,
        priceRange: "60k - 150k €/semaine"
      },

      // Italie
      {
        id: "costa-smeralda",
        name: "Costa Smeralda",
        country: "Sardaigne, Italie",
        description: "Émeraude sarde d'exception",
        image: "https://images.unsplash.com/photo-1533656338503-b22f63e96cd8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
        villaCount: 16,
        priceRange: "25k - 65k €/semaine"
      },
      {
        id: "amalfi-coast",
        name: "Côte Amalfitaine",
        country: "Italie",
        description: "Théâtre sublime de la Méditerranée",
        image: "https://images.unsplash.com/photo-1561956021-947f09ae0101?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
        villaCount: 20,
        priceRange: "30k - 75k €/semaine"
      },
      {
        id: "forte-dei-marmi",
        name: "Forte dei Marmi",
        country: "Toscane, Italie",
        description: "Élégance toscane en bord de mer",
        image: "https://images.pexels.com/photos/3225528/pexels-photo-3225528.jpeg?auto=compress&cs=tinysrgb&w=1000&h=1200&fit=crop",
        villaCount: 12,
        priceRange: "28k - 60k €/semaine"
      },

      // Grèce
      {
        id: "mykonos",
        name: "Mykonos",
        country: "Grèce",
        description: "L'île festive par excellence",
        image: "https://images.unsplash.com/photo-1613395877344-13d4a8e0d49e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
        villaCount: 18,
        priceRange: "22k - 55k €/semaine"
      },
      {
        id: "santorini",
        name: "Santorin",
        country: "Grèce",
        description: "Couchers de soleil légendaires",
        image: "https://images.unsplash.com/photo-1688664562000-4c1f7cdb48f8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
        villaCount: 14,
        priceRange: "26k - 65k €/semaine"
      },
      {
        id: "paros",
        name: "Paros",
        country: "Grèce",
        description: "Authenticité cycladique préservée",
        image: "https://images.pexels.com/photos/1029021/pexels-photo-1029021.jpeg?auto=compress&cs=tinysrgb&w=1000&h=1200&fit=crop",
        villaCount: 10,
        priceRange: "18k - 42k €/semaine"
      },
      {
        id: "corfu",
        name: "Corfou",
        country: "Grèce",
        description: "Joyau ionien verdoyant",
        image: "https://images.unsplash.com/photo-1722581174702-706197ded63d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
        villaCount: 8,
        priceRange: "20k - 48k €/semaine"
      },

      // Espagne
      {
        id: "marbella",
        name: "Marbella",
        country: "Andalousie, Espagne",
        description: "Glamour méditerranéen espagnol",
        image: "https://images.unsplash.com/photo-1632464477484-04c89665d5bb?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
        villaCount: 15,
        priceRange: "25k - 60k €/semaine"
      },
      {
        id: "mallorca",
        name: "Palma de Mallorca",
        country: "Baléares, Espagne",
        description: "Perle des Baléares",
        image: "https://images.unsplash.com/photo-1632153604387-1a54695882a2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
        villaCount: 20,
        priceRange: "20k - 50k €/semaine"
      },
      {
        id: "formentera",
        name: "Formentera",
        country: "Baléares, Espagne",
        description: "Paradis bohème chic",
        image: "https://images.unsplash.com/photo-1632464477484-04c89665d5bb?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
        villaCount: 8,
        priceRange: "22k - 55k €/semaine"
      }
    ]
  }
};